import React from 'react'

const InfanionLogo = () => {
    return (
        <div>
            <svg width="170" height="60" viewBox="0 0 152 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 18.1543V1.53711H3.91816V18.1543H0Z" fill="white" />
                <path d="M11.2927 18.153V4.5379H13.6045L25.3128 13.5776V4.5379H28.348V18.153H26.0227L14.3495 8.97123V18.153H11.2927Z" fill="white" />
                <path d="M34.5068 18.153V4.5379H49.1421V6.97468H37.8985V10.5275H43.9502V13.0593H37.8985V18.153H34.5068Z" fill="white" />
                <path d="M47.9688 18.1522L56.1548 4.53711H59.3876L67.7005 18.1522H63.9262L62.1909 15.1654H53.0652L51.3298 18.1522H47.9688ZM54.4985 12.6808H60.8209L57.6045 7.00481L54.4985 12.6808Z" fill="white" />
                <path d="M71.1416 18.153V4.5379H73.4535L85.1617 13.5776V4.5379H88.2029V18.153H85.8783L74.2044 8.97123V18.153H71.1416Z" fill="white" />
                <path d="M94.3594 18.1522V4.53711H97.7041V18.1522H94.3594Z" fill="white" />
                <path d="M104.426 4.27651C104.426 2.62745 104.752 1.50231 105.403 0.901093C106.055 0.299874 107.322 -0.000490191 109.207 6.0048e-07H123.433C125.33 6.0048e-07 126.601 0.300364 127.244 0.901093C127.887 1.50182 128.211 2.62696 128.214 4.27651V13.8558C128.214 15.5196 127.884 16.6518 127.225 17.2526C126.567 17.8533 125.303 18.1534 123.436 18.1529H109.209C107.326 18.1529 106.058 17.8528 105.406 17.2526C104.753 16.6523 104.428 15.5201 104.429 13.8558L104.426 4.27651ZM108.906 14.6737H123.728V3.3364H108.906V14.6737Z" fill="#0099FF" />
                <path d="M134.939 18.153V4.5379H137.251L148.959 13.5776V4.5379H152.001V18.153H149.667L137.994 8.97123V18.153H134.939Z" fill="white" />
            </svg>

        </div>
    )
}

export default InfanionLogo
